import type { SiteConfig } from '../../@types/context/site-config.types';

export const contactZmartaSeConfig: Pick<SiteConfig, 'contact'> = {
  contact: {
    phone: '0431 474768',
    email: 'info@zmarta.se',
  },
};
